import { Inline } from '@etg/wings';
import { constants, price as priceUtils } from '@eti/utils';
import { screenReaderOnly } from '../../utils/styles';
import { selectBoxOptionLabelStyles } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  MOUSE_FLOW_CLASS_NAMES
} = constants;
const OptionLabel = ({
  label,
  price
}) => {
  return /*#__PURE__*/_jsxs(Inline, {
    className: selectBoxOptionLabelStyles,
    "data-testid": "option-label",
    noWrap: true,
    spacing: 4,
    children: [/*#__PURE__*/_jsx("span", {
      className: MOUSE_FLOW_CLASS_NAMES,
      children: label
    }), /*#__PURE__*/_jsx("span", {
      "aria-hidden": true,
      className: "option-label-price",
      children: price
    }), /*#__PURE__*/_jsx("span", {
      className: screenReaderOnly,
      children: priceUtils.replaceWithCurrencyName(price)
    })]
  });
};
export default OptionLabel;
//# sourceMappingURL=OptionLabel.js.map